import {BaseWidgetSettings} from "./base-settings.type";
import {IBaseLanguageDesign} from "../../structural";

//basically just because GraphQL needs some interface
export type LanguagePickerSettings = {
  showFlags: boolean;
} & IBaseLanguageDesign & BaseWidgetSettings;
